// extracted by mini-css-extract-plugin
module.exports = {"burgerSectionContainer":"home_burgerSectionContainer__1LgGl"};